import { Injectable } from '@angular/core';
import { AgentFindInterface } from '@zaoblako/shared/modules/ai/dtos/agent/agent-find.dto';
import type { ClientFindInterface } from '@zaoblako/shared/modules/client/dtos/client/client-find.dto';
import type { HelpdeskNotificationSettingsFindInterface } from '@zaoblako/shared/modules/helpdesk/dto/helpdesk-notification-settings.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HelpDeskSettingsService extends BaseService {
  protected baseUrl = '/helpdesk/settings';

  public getNotificationSettings(): Observable<HelpdeskNotificationSettingsFindInterface> {
    return this.http.get<HelpdeskNotificationSettingsFindInterface>(`${this.baseUrl}/notification-settings`);
  }

  public updateNotificationSettings(
    body: HelpdeskNotificationSettingsFindInterface
  ): Observable<HelpdeskNotificationSettingsFindInterface> {
    return this.http.put<HelpdeskNotificationSettingsFindInterface>(`${this.baseUrl}/notification-settings`, body);
  }

  public getDefaultClient(): Observable<ClientFindInterface> {
    return this.http.get<ClientFindInterface>(`${this.baseUrl}/client`);
  }

  public setDefaultClient(id: number): Observable<ClientFindInterface> {
    return this.http.put<ClientFindInterface>(`${this.baseUrl}/client/${id}`, {});
  }

  public getDefaultAgent(): Observable<AgentFindInterface> {
    return this.http.get<AgentFindInterface>(`${this.baseUrl}/agent`);
  }

  public setDefaultAgent(id: number): Observable<AgentFindInterface> {
    return this.http.put<AgentFindInterface>(`${this.baseUrl}/agent/${id}`, null);
  }
}
